import BaseController from './basePlayerController';

export default class ControllerMenu extends BaseController {
  constructor({ container, ...props }) {
    super({ ...props });
    this._eButtonsTypes = {
      EBT_BURGER: 'menu_button',
    };
    this._eEventTypes =  {
      BURGER_CLICK: this.getEventName(this._eButtonsTypes.EBT_BURGER),
    };
    this._eElementsTypes = {
      EET_BURGER_BUTTON: this._eButtonsTypes.EBT_BURGER,
    };

    this.init(container);
  }

  _getMarkup() {
    return `<button id=${this.interactiveElementsIds[this._eElementsTypes.EET_BURGER_BUTTON]} data-color="primary">
            <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 43.5023H72.69" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M15 62.1705H72.69" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M15 24.8341H72.69" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>`
  }
}
